export const mainLoader = require("../Assets/Lottie/mainLoader.json");
